import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { Consumer as FieldsetContextConsumer } from 'UIComponents/context/FieldsetContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BrowserFooterPropTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
const BrowserFooter = ({
  className,
  disabled,
  onCancel,
  onConfirm
}) => {
  return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
    children: ({
      size: fieldSize
    }) => {
      return /*#__PURE__*/_jsxs("div", {
        className: className,
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "insert-token-confirm-button",
          use: "tertiary",
          onClick: onConfirm,
          disabled: !!disabled,
          size: fieldSize,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "data-token-picker.confirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "insert-token-cancel-button",
          use: "tertiary-light",
          onClick: onCancel,
          size: fieldSize,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "data-token-picker.cancel"
          })
        })]
      });
    }
  });
};
BrowserFooter.propTypes = BrowserFooterPropTypes;
BrowserFooter.displayName = 'BrowserFooter';
export default BrowserFooter;